import type { PropsWithChildren } from "react";

import { Button } from "@similarweb/ui-components";

import { translate } from "app/filters/i18nFilter";
import { CANCEL, DOWNLOAD } from "app/pages/sales-intelligence/modules/enrichment/utils/i18n/modal.texts";
import enrichmentTrackingService from "app/pages/sales-intelligence/services/tracking/enrichment/trackingService";
import { PlainTooltip } from "app/components/React/Tooltip/PlainTooltip/PlainTooltip";
import { selectExcelQuota } from "app/pages/sales-intelligence/sub-modules/common/store/selectors";

import { StyledModalFooter, StyledButtonGroup } from "../../containers/EnrichmentCsvContainer/style";

type Props = PropsWithChildren<{
    isDisabled: boolean;
    isLoading?: boolean;
    isEnriching?: boolean;
    isOutOfQuota: boolean;
    onClose: VoidFunction;
    onConfirm: VoidFunction;
}>;

export const Footer = ({ isLoading, isDisabled, isEnriching, isOutOfQuota, onClose, onConfirm, children }: Props) => {
    const handleClose = (): void => {
        onClose();
        enrichmentTrackingService.csv.company.trackCancelEnrichment();
    };

    return (
        <StyledModalFooter data-automation="footer">
            {children}

            <StyledButtonGroup>
                <Button
                    className="cancel"
                    onClick={handleClose}
                    type="flat"
                >
                    {translate(CANCEL)}
                </Button>
                <Button
                    isLoading={isEnriching}
                    isDisabled={isDisabled || isOutOfQuota || isLoading}
                    onClick={onConfirm}
                    type="primary"
                >
                    {translate(DOWNLOAD)}
                </Button>
            </StyledButtonGroup>
        </StyledModalFooter>
    );
};
